<template lang="pug">
#home
  vheader
  mobile-nav
  .entry
    .cover
      .container
        h1 志愿者招募
    .container.min
      .entry-list.about
        p 前沿社长期招募志愿者，我们欢迎这样的你：
        ul
          li 热爱科技、充满好奇心
          li 有相关科技行业相关实习经历，在读或者应届毕业生均可
          li 具有良好的职业形象，沟通能力强，执行力强
          li 熟练使用包括Keynote、Powerpoint等办公软件
          li 英文听说读写熟练
        p 作为志愿者，你将有机会：
        ul
          li 实时了解最前沿的科学与技术潮流动态
          li 每月与最优秀的创业者一同学习、思维保先
          li 每季度近距离接触全球最权威的科技专家
        p
          | 一年两次参与体验极客公园最强势IP大会的筹备全过程
          br
          br
          | 当然还有
          br
          | 舒适愉快的办公环境
          br
          | 美味可口的「极客食堂」
          br
          | 欢迎投递简历至：<a href="mailto:thefrontier@geekpark.net">thefrontier@geekpark.net</a>
  footer-user
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import FooterUser from '../components/FooterUser.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  data() {
    return {
      link: 'http://cn.mikecrm.com/bpvLg71'
    }
  },
  components: {
    Vheader,
    Vfooter,
    FooterUser,
    MobileNav
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
.entry-list.about
  p
    font-size 16px
@media $media
  .entry-list.about
    p
      font-size 14px
</style>



// WEBPACK FOOTER //
// Volunteers.vue?4865dca2